module.exports = __webpack_public_path__ + "img/introduciton.4104867a.png";